const STORAGE_KEY = 'postLoginRedirect';
const DEFAULT_REDIRECT = '/tenants';

// Structural rather than react-router's Location: the api interceptor saves the
// current page from outside React, where all it has is globalThis.location.
interface RedirectTarget {
  pathname: string;
  search: string;
  hash: string;
}

export const savePostLoginRedirect = (location: RedirectTarget): void => {
  const path = `${location.pathname}${location.search}${location.hash}`;
  sessionStorage.setItem(STORAGE_KEY, path);
};

export const getAndClearPostLoginRedirect = (): string => {
  const path = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);

  if (!path || !path.startsWith('/') || path.startsWith('//')) {
    return DEFAULT_REDIRECT;
  }

  return path;
};
